import {
  enableProdMode,
  provideZoneChangeDetection
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import {
  appConfig,
  firebaseConfig
} from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(
  AppComponent,
  {
    ...appConfig,
    providers: [
      provideZoneChangeDetection(),
      ...appConfig.providers,
      ...firebaseConfig.providers,
    ]
  })
  .catch((err) => {
      if (!environment.production) {
          console.error('Application bootstrap error:', err);
      } else {
          console.error('Application failed to start. Please try again later.');
      }
  });
